import {money} from "../../../core/forms/money";
import Data from "../../../core/data/Data";

export const CorporateDashboard = {
    mixins: [money],
    data() {
        return {
            data: new Data({
                url: "/business/batches/list",
                prefix: "list"
            }),
            wallets: [],
            transactions: [],
            loading: true,
            transaction: {},
        };
    },
    methods: {
        init() {
            this.loading = true;

            this.data.filters.size = 5;
            this.data.fetch()

            window.axios.get(`${window.location.origin}/business/dashboard/api`).then((response) => {
                this.wallets = response.data.body.wallets;
                this.transactions = response.data.body.transactions.slice(0, 7);
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    mounted() {
        this.init();
    },
    metaInfo: {
        title: 'Corporate Dashboard'
    }
}
